(function (lib, img, cjs, ss, an) {

var p; // shortcut to reference prototypes
lib.webFontTxtInst = {}; 
var loadedTypekitCount = 0;
var loadedGoogleCount = 0;
var gFontsUpdateCacheList = [];
var tFontsUpdateCacheList = [];
lib.ssMetadata = [];



lib.updateListCache = function (cacheList) {		
	for(var i = 0; i < cacheList.length; i++) {		
		if(cacheList[i].cacheCanvas)		
			cacheList[i].updateCache();		
	}		
};		

lib.addElementsToCache = function (textInst, cacheList) {		
	var cur = textInst;		
	while(cur != exportRoot) {		
		if(cacheList.indexOf(cur) != -1)		
			break;		
		cur = cur.parent;		
	}		
	if(cur != exportRoot) {		
		var cur2 = textInst;		
		var index = cacheList.indexOf(cur);		
		while(cur2 != cur) {		
			cacheList.splice(index, 0, cur2);		
			cur2 = cur2.parent;		
			index++;		
		}		
	}		
	else {		
		cur = textInst;		
		while(cur != exportRoot) {		
			cacheList.push(cur);		
			cur = cur.parent;		
		}		
	}		
};		

lib.gfontAvailable = function(family, totalGoogleCount) {		
	lib.properties.webfonts[family] = true;		
	var txtInst = lib.webFontTxtInst && lib.webFontTxtInst[family] || [];		
	for(var f = 0; f < txtInst.length; ++f)		
		lib.addElementsToCache(txtInst[f], gFontsUpdateCacheList);		

	loadedGoogleCount++;		
	if(loadedGoogleCount == totalGoogleCount) {		
		lib.updateListCache(gFontsUpdateCacheList);		
	}		
};		

lib.tfontAvailable = function(family, totalTypekitCount) {		
	lib.properties.webfonts[family] = true;		
	var txtInst = lib.webFontTxtInst && lib.webFontTxtInst[family] || [];		
	for(var f = 0; f < txtInst.length; ++f)		
		lib.addElementsToCache(txtInst[f], tFontsUpdateCacheList);		

	loadedTypekitCount++;		
	if(loadedTypekitCount == totalTypekitCount) {		
		lib.updateListCache(tFontsUpdateCacheList);		
	}		
};
// symbols:



(lib.headerimg = function() {
	this.initialize(img.headerimg);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1600,500);


// stage content:
(lib.Untitled2 = function(mode,startPosition,loop) {
if (loop == null) { loop = false; }	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgFAtQgIgBgJgFQgIgFgFgGQgGgHgCgIQgCgIABgJQABgIAFgJQAFgJAHgGQAIgFAIgCQAIgCAIABQAIABAIAFQAJAFAFAGQAGAHACAIQACAIgBAJQgBAIgFAJQgFAJgIAGQgHAFgIACIgLACIgFgBgAgIgZQgEABgEADQgEADgDAFQgDAFAAAFQgBAEABAEQACAFADAEQAEAEAFADQAGAEAGABQAEABAFgBQAEgBAEgDQAEgDADgFQADgFAAgFQABgEgBgEQgCgFgDgEQgEgEgGgEQgFgDgGgBIgEAAIgFAAg");
	this.shape.setTransform(325.5,194.9);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("Ag4ALIAKgQIAeAQIACgDQACgEgBgDIgPgeIgBgFIACgEIAJgQIARAoIABAEIAAAEIAEgCIAFgBIAwgDIgJAPIgBACIgCACIgCAAIgCAAIgkADIgDABIgCADIgDAFIAfASIgKASg");
	this.shape_1.setTransform(321.2,202.5);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("Ag4ALIAGgJIABgCIABgBIACAAIACgBIBBgJIgEgDIgFgBIgngXIAJgQIBLAsIgFAJIgDACIgEABIhAAKIAEACIADACIAoAXIgJAQg");
	this.shape_2.setTransform(316.6,210.3);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("AgygbIAKgSIBbAPIgHANIgEAEQAAAAgBAAQAAABgBAAQAAAAgBAAQAAAAgBAAIgPgEIgRAcIAKAMQABAAAAABQAAAAABAAQAAABAAAAQAAABAAAAIgBAFIgIANgAgZgVIAEAEIAQASIALgUIgXgEIgGgCIgHgCIAFAGg");
	this.shape_3.setTransform(313,219.5);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("Ag4ALIALgRIAfARIARgdIgfgSIAKgSIBLAsIgKAQIgggRIgRAdIAfATIgKASg");
	this.shape_4.setTransform(307.7,225.8);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FFFFFF").s().p("AgpggIBTAvIhCASg");
	this.shape_5.setTransform(304.9,232.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(115));

	// Layer 13
	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#FFFFFF").s().p("AgxgwIBjA4IhZAqg");
	this.shape_6.setTransform(94.3,435.5);
	this.shape_6._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape_6).wait(102).to({_off:false},0).wait(13));

	// Layer 16
	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#FFFFFF").s().p("AgugUIBcgjIgdBvg");
	this.shape_7.setTransform(203.1,255.8);
	this.shape_7._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape_7).wait(74).to({_off:false},0).wait(41));

	// Layer 15
	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#FFFFFF").s().p("AgwAhIBRhRIAQBhg");
	this.shape_8.setTransform(438.9,253.8);
	this.shape_8._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape_8).wait(67).to({_off:false},0).wait(48));

	// Layer 14
	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#FFFFFF").s().p("AAAgnIA6BPIhzAAg");
	this.shape_9.setTransform(321.5,9.3);
	this.shape_9._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape_9).wait(114).to({_off:false},0).wait(1));

	// Layer 12
	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f().s("#FFFFFF").ss(1.9,1,1).p("ABFAAQAAAcgUAVQgUAUgdAAQgcAAgUgUQgUgVAAgcQAAgbAUgVQAUgUAcAAQAdAAAUAUQAUAVAAAbg");
	this.shape_10.setTransform(297.9,246.7);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#0066CC").s().p("AgwAyQgUgWAAgcQAAgbAUgVQATgUAdAAQAdAAAUAUQAUAVAAAbQAAAcgUAWQgUATgdAAQgdAAgTgTg");
	this.shape_11.setTransform(297.9,246.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_11},{t:this.shape_10}]}).wait(115));

	// Layer 9 copy 3
	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAArIAAhW");
	this.shape_12.setTransform(321.9,63.7);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAg7IAAB3");
	this.shape_13.setTransform(321.9,62.1);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAhLIAACX");
	this.shape_14.setTransform(321.9,60.5);

	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAhcIAAC5");
	this.shape_15.setTransform(321.9,58.8);

	this.shape_16 = new cjs.Shape();
	this.shape_16.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAhsIAADZ");
	this.shape_16.setTransform(321.9,57.2);

	this.shape_17 = new cjs.Shape();
	this.shape_17.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAh8IAAD5");
	this.shape_17.setTransform(321.9,55.6);

	this.shape_18 = new cjs.Shape();
	this.shape_18.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAiMIAAEZ");
	this.shape_18.setTransform(321.9,53.9);

	this.shape_19 = new cjs.Shape();
	this.shape_19.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAidIAAE7");
	this.shape_19.setTransform(321.9,52.3);

	this.shape_20 = new cjs.Shape();
	this.shape_20.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAitIAAFb");
	this.shape_20.setTransform(321.9,50.7);

	this.shape_21 = new cjs.Shape();
	this.shape_21.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAi9IAAF7");
	this.shape_21.setTransform(321.9,49);

	this.shape_22 = new cjs.Shape();
	this.shape_22.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAjOIAAGd");
	this.shape_22.setTransform(321.9,47.4);

	this.shape_23 = new cjs.Shape();
	this.shape_23.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAjeIAAG9");
	this.shape_23.setTransform(321.9,45.8);

	this.shape_24 = new cjs.Shape();
	this.shape_24.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAjuIAAHd");
	this.shape_24.setTransform(321.9,44.2);

	this.shape_25 = new cjs.Shape();
	this.shape_25.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAj/IAAH+");
	this.shape_25.setTransform(321.9,42.5);

	this.shape_26 = new cjs.Shape();
	this.shape_26.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAkPIAAIf");
	this.shape_26.setTransform(321.9,40.9);

	this.shape_27 = new cjs.Shape();
	this.shape_27.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAEgIAAo/");
	this.shape_27.setTransform(321.9,39.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_12}]},99).to({state:[{t:this.shape_13}]},1).to({state:[{t:this.shape_14}]},1).to({state:[{t:this.shape_15}]},1).to({state:[{t:this.shape_16}]},1).to({state:[{t:this.shape_17}]},1).to({state:[{t:this.shape_18}]},1).to({state:[{t:this.shape_19}]},1).to({state:[{t:this.shape_20}]},1).to({state:[{t:this.shape_21}]},1).to({state:[{t:this.shape_22}]},1).to({state:[{t:this.shape_23}]},1).to({state:[{t:this.shape_24}]},1).to({state:[{t:this.shape_25}]},1).to({state:[{t:this.shape_26}]},1).to({state:[{t:this.shape_27}]},1).wait(1));

	// Layer 9 copy 2
	this.shape_28 = new cjs.Shape();
	this.shape_28.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgVAeIArg7");
	this.shape_28.setTransform(267.3,143.5);

	this.shape_29 = new cjs.Shape();
	this.shape_29.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgbAnIA3hN");
	this.shape_29.setTransform(268,142.7);

	this.shape_30 = new cjs.Shape();
	this.shape_30.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AghAwIBDhf");
	this.shape_30.setTransform(268.6,141.8);

	this.shape_31 = new cjs.Shape();
	this.shape_31.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgoA4IBRhv");
	this.shape_31.setTransform(269.2,141);

	this.shape_32 = new cjs.Shape();
	this.shape_32.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AguBBIBdiB");
	this.shape_32.setTransform(269.8,140.1);

	this.shape_33 = new cjs.Shape();
	this.shape_33.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ag0BKIBpiS");
	this.shape_33.setTransform(270.5,139.2);

	this.shape_34 = new cjs.Shape();
	this.shape_34.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ag6BSIB1ij");
	this.shape_34.setTransform(271.1,138.4);

	this.shape_35 = new cjs.Shape();
	this.shape_35.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhBBbICDi1");
	this.shape_35.setTransform(271.7,137.5);

	this.shape_36 = new cjs.Shape();
	this.shape_36.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhGBjICOjF");
	this.shape_36.setTransform(272.3,136.6);

	this.shape_37 = new cjs.Shape();
	this.shape_37.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhNBsICbjX");
	this.shape_37.setTransform(272.9,135.8);

	this.shape_38 = new cjs.Shape();
	this.shape_38.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhTB1ICnjp");
	this.shape_38.setTransform(273.6,134.9);

	this.shape_39 = new cjs.Shape();
	this.shape_39.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhZB9ICzj5");
	this.shape_39.setTransform(274.2,134.1);

	this.shape_40 = new cjs.Shape();
	this.shape_40.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhfCGIDAkL");
	this.shape_40.setTransform(274.8,133.2);

	this.shape_41 = new cjs.Shape();
	this.shape_41.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhmCPIDNkd");
	this.shape_41.setTransform(275.4,132.3);

	this.shape_42 = new cjs.Shape();
	this.shape_42.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhsCXIDZkt");
	this.shape_42.setTransform(276.1,131.5);

	this.shape_43 = new cjs.Shape();
	this.shape_43.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhyCgIDlk/");
	this.shape_43.setTransform(276.7,130.6);

	this.shape_44 = new cjs.Shape();
	this.shape_44.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ah4CoIDylP");
	this.shape_44.setTransform(277.3,129.7);

	this.shape_45 = new cjs.Shape();
	this.shape_45.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ah/CxID/lh");
	this.shape_45.setTransform(277.9,128.9);

	this.shape_46 = new cjs.Shape();
	this.shape_46.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiFC6IELly");
	this.shape_46.setTransform(278.6,128);

	this.shape_47 = new cjs.Shape();
	this.shape_47.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiLDCIEXmD");
	this.shape_47.setTransform(279.2,127.2);

	this.shape_48 = new cjs.Shape();
	this.shape_48.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiRDLIEkmV");
	this.shape_48.setTransform(279.8,126.3);

	this.shape_49 = new cjs.Shape();
	this.shape_49.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiYDTIExml");
	this.shape_49.setTransform(280.4,125.4);

	this.shape_50 = new cjs.Shape();
	this.shape_50.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AieDcIE9m3");
	this.shape_50.setTransform(281,124.6);

	this.shape_51 = new cjs.Shape();
	this.shape_51.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AikDlIFJnJ");
	this.shape_51.setTransform(281.7,123.7);

	this.shape_52 = new cjs.Shape();
	this.shape_52.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiqDtIFVnZ");
	this.shape_52.setTransform(282.3,122.8);

	this.shape_53 = new cjs.Shape();
	this.shape_53.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AixD2IFjnr");
	this.shape_53.setTransform(282.9,122);

	this.shape_54 = new cjs.Shape();
	this.shape_54.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ai3D+IFvn8");
	this.shape_54.setTransform(283.5,121.1);

	this.shape_55 = new cjs.Shape();
	this.shape_55.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ai9EHIF7oN");
	this.shape_55.setTransform(284.2,120.3);

	this.shape_56 = new cjs.Shape();
	this.shape_56.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AjDEQIGHof");
	this.shape_56.setTransform(284.8,119.4);

	this.shape_57 = new cjs.Shape();
	this.shape_57.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AjKEYIGVov");
	this.shape_57.setTransform(285.4,118.5);

	this.shape_58 = new cjs.Shape();
	this.shape_58.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AjQEhIGhpB");
	this.shape_58.setTransform(286,117.7);

	this.shape_59 = new cjs.Shape();
	this.shape_59.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AjWEqIGtpT");
	this.shape_59.setTransform(286.7,116.8);

	this.shape_60 = new cjs.Shape();
	this.shape_60.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AjcEyIG5pj");
	this.shape_60.setTransform(287.3,115.9);

	this.shape_61 = new cjs.Shape();
	this.shape_61.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AjjE7IHHp1");
	this.shape_61.setTransform(287.9,115.1);

	this.shape_62 = new cjs.Shape();
	this.shape_62.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AjpFDIHTqG");
	this.shape_62.setTransform(288.5,114.2);

	this.shape_63 = new cjs.Shape();
	this.shape_63.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AjvFMIHfqX");
	this.shape_63.setTransform(289.1,113.4);

	this.shape_64 = new cjs.Shape();
	this.shape_64.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Aj1FVIHrqp");
	this.shape_64.setTransform(289.8,112.5);

	this.shape_65 = new cjs.Shape();
	this.shape_65.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Aj7FdIH3q5");
	this.shape_65.setTransform(290.4,111.6);

	this.shape_66 = new cjs.Shape();
	this.shape_66.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AkCFmIIFrL");
	this.shape_66.setTransform(291,110.8);

	this.shape_67 = new cjs.Shape();
	this.shape_67.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AkIFvIIRrd");
	this.shape_67.setTransform(291.6,109.9);

	this.shape_68 = new cjs.Shape();
	this.shape_68.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AkOF3IIdrt");
	this.shape_68.setTransform(292.3,109);

	this.shape_69 = new cjs.Shape();
	this.shape_69.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AkUGAIIpr/");
	this.shape_69.setTransform(292.9,108.2);

	this.shape_70 = new cjs.Shape();
	this.shape_70.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AkbGJII3sR");
	this.shape_70.setTransform(293.5,107.3);
	this.shape_70._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_28}]},57).to({state:[{t:this.shape_29}]},1).to({state:[{t:this.shape_30}]},1).to({state:[{t:this.shape_31}]},1).to({state:[{t:this.shape_32}]},1).to({state:[{t:this.shape_33}]},1).to({state:[{t:this.shape_34}]},1).to({state:[{t:this.shape_35}]},1).to({state:[{t:this.shape_36}]},1).to({state:[{t:this.shape_37}]},1).to({state:[{t:this.shape_38}]},1).to({state:[{t:this.shape_39}]},1).to({state:[{t:this.shape_40}]},1).to({state:[{t:this.shape_41}]},1).to({state:[{t:this.shape_42}]},1).to({state:[{t:this.shape_43}]},1).to({state:[{t:this.shape_44}]},1).to({state:[{t:this.shape_45}]},1).to({state:[{t:this.shape_46}]},1).to({state:[{t:this.shape_47}]},1).to({state:[{t:this.shape_48}]},1).to({state:[{t:this.shape_49}]},1).to({state:[{t:this.shape_50}]},1).to({state:[{t:this.shape_51}]},1).to({state:[{t:this.shape_52}]},1).to({state:[{t:this.shape_53}]},1).to({state:[{t:this.shape_54}]},1).to({state:[{t:this.shape_55}]},1).to({state:[{t:this.shape_56}]},1).to({state:[{t:this.shape_57}]},1).to({state:[{t:this.shape_58}]},1).to({state:[{t:this.shape_59}]},1).to({state:[{t:this.shape_60}]},1).to({state:[{t:this.shape_61}]},1).to({state:[{t:this.shape_62}]},1).to({state:[{t:this.shape_63}]},1).to({state:[{t:this.shape_64}]},1).to({state:[{t:this.shape_65}]},1).to({state:[{t:this.shape_66}]},1).to({state:[{t:this.shape_67}]},1).to({state:[{t:this.shape_68}]},1).to({state:[{t:this.shape_69}]},1).to({state:[{t:this.shape_70}]},1).to({state:[{t:this.shape_70}]},1).to({state:[{t:this.shape_70}]},1).to({state:[{t:this.shape_70}]},1).to({state:[{t:this.shape_70}]},1).to({state:[{t:this.shape_70}]},1).to({state:[{t:this.shape_70}]},1).to({state:[{t:this.shape_70}]},1).to({state:[{t:this.shape_70}]},1).to({state:[{t:this.shape_70}]},1).to({state:[{t:this.shape_70}]},1).to({state:[{t:this.shape_70}]},1).to({state:[{t:this.shape_70}]},1).to({state:[{t:this.shape_70}]},1).to({state:[{t:this.shape_70}]},1).to({state:[{t:this.shape_70}]},1).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.shape_70).wait(99).to({_off:false},0).wait(16));

	// Layer 9 copy
	this.shape_71 = new cjs.Shape();
	this.shape_71.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAAsIAAhX");
	this.shape_71.setTransform(265.2,218.1);

	this.shape_72 = new cjs.Shape();
	this.shape_72.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAg1IAABr");
	this.shape_72.setTransform(265.2,217);

	this.shape_73 = new cjs.Shape();
	this.shape_73.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAhAIAACB");
	this.shape_73.setTransform(265.2,216);

	this.shape_74 = new cjs.Shape();
	this.shape_74.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAhKIAACV");
	this.shape_74.setTransform(265.2,214.9);

	this.shape_75 = new cjs.Shape();
	this.shape_75.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAhVIAACr");
	this.shape_75.setTransform(265.2,213.9);

	this.shape_76 = new cjs.Shape();
	this.shape_76.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAhfIAAC/");
	this.shape_76.setTransform(265.2,212.8);

	this.shape_77 = new cjs.Shape();
	this.shape_77.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAhqIAADV");
	this.shape_77.setTransform(265.2,211.8);

	this.shape_78 = new cjs.Shape();
	this.shape_78.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAh0IAADp");
	this.shape_78.setTransform(265.2,210.7);

	this.shape_79 = new cjs.Shape();
	this.shape_79.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAh/IAAD/");
	this.shape_79.setTransform(265.2,209.7);

	this.shape_80 = new cjs.Shape();
	this.shape_80.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAiJIAAET");
	this.shape_80.setTransform(265.2,208.6);

	this.shape_81 = new cjs.Shape();
	this.shape_81.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAiUIAAEp");
	this.shape_81.setTransform(265.2,207.6);

	this.shape_82 = new cjs.Shape();
	this.shape_82.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAieIAAE9");
	this.shape_82.setTransform(265.2,206.5);

	this.shape_83 = new cjs.Shape();
	this.shape_83.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAipIAAFT");
	this.shape_83.setTransform(265.2,205.5);

	this.shape_84 = new cjs.Shape();
	this.shape_84.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAizIAAFn");
	this.shape_84.setTransform(265.2,204.4);

	this.shape_85 = new cjs.Shape();
	this.shape_85.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAi+IAAF9");
	this.shape_85.setTransform(265.2,203.4);

	this.shape_86 = new cjs.Shape();
	this.shape_86.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAjIIAAGR");
	this.shape_86.setTransform(265.2,202.3);

	this.shape_87 = new cjs.Shape();
	this.shape_87.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAjTIAAGm");
	this.shape_87.setTransform(265.2,201.3);

	this.shape_88 = new cjs.Shape();
	this.shape_88.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAjdIAAG7");
	this.shape_88.setTransform(265.2,200.3);

	this.shape_89 = new cjs.Shape();
	this.shape_89.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAjoIAAHR");
	this.shape_89.setTransform(265.2,199.2);

	this.shape_90 = new cjs.Shape();
	this.shape_90.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAjyIAAHl");
	this.shape_90.setTransform(265.2,198.2);

	this.shape_91 = new cjs.Shape();
	this.shape_91.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAj8IAAH5");
	this.shape_91.setTransform(265.2,197.1);

	this.shape_92 = new cjs.Shape();
	this.shape_92.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAkHIAAIP");
	this.shape_92.setTransform(265.2,196.1);

	this.shape_93 = new cjs.Shape();
	this.shape_93.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAkRIAAIj");
	this.shape_93.setTransform(265.2,195);

	this.shape_94 = new cjs.Shape();
	this.shape_94.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAkcIAAI5");
	this.shape_94.setTransform(265.2,194);

	this.shape_95 = new cjs.Shape();
	this.shape_95.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAkmIAAJO");
	this.shape_95.setTransform(265.2,192.9);

	this.shape_96 = new cjs.Shape();
	this.shape_96.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAkxIAAJj");
	this.shape_96.setTransform(265.2,191.9);

	this.shape_97 = new cjs.Shape();
	this.shape_97.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAk8IAAJ4");
	this.shape_97.setTransform(265.2,190.8);

	this.shape_98 = new cjs.Shape();
	this.shape_98.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAlGIAAKN");
	this.shape_98.setTransform(265.2,189.8);

	this.shape_99 = new cjs.Shape();
	this.shape_99.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAlRIAAKj");
	this.shape_99.setTransform(265.2,188.7);

	this.shape_100 = new cjs.Shape();
	this.shape_100.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAlbIAAK3");
	this.shape_100.setTransform(265.2,187.7);

	this.shape_101 = new cjs.Shape();
	this.shape_101.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAllIAALL");
	this.shape_101.setTransform(265.2,186.6);

	this.shape_102 = new cjs.Shape();
	this.shape_102.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAlwIAALh");
	this.shape_102.setTransform(265.2,185.6);

	this.shape_103 = new cjs.Shape();
	this.shape_103.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAAF7IAAr1");
	this.shape_103.setTransform(265.2,184.5);
	this.shape_103._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_71}]},25).to({state:[{t:this.shape_72}]},1).to({state:[{t:this.shape_73}]},1).to({state:[{t:this.shape_74}]},1).to({state:[{t:this.shape_75}]},1).to({state:[{t:this.shape_76}]},1).to({state:[{t:this.shape_77}]},1).to({state:[{t:this.shape_78}]},1).to({state:[{t:this.shape_79}]},1).to({state:[{t:this.shape_80}]},1).to({state:[{t:this.shape_81}]},1).to({state:[{t:this.shape_82}]},1).to({state:[{t:this.shape_83}]},1).to({state:[{t:this.shape_84}]},1).to({state:[{t:this.shape_85}]},1).to({state:[{t:this.shape_86}]},1).to({state:[{t:this.shape_87}]},1).to({state:[{t:this.shape_88}]},1).to({state:[{t:this.shape_89}]},1).to({state:[{t:this.shape_90}]},1).to({state:[{t:this.shape_91}]},1).to({state:[{t:this.shape_92}]},1).to({state:[{t:this.shape_93}]},1).to({state:[{t:this.shape_94}]},1).to({state:[{t:this.shape_95}]},1).to({state:[{t:this.shape_96}]},1).to({state:[{t:this.shape_97}]},1).to({state:[{t:this.shape_98}]},1).to({state:[{t:this.shape_99}]},1).to({state:[{t:this.shape_100}]},1).to({state:[{t:this.shape_101}]},1).to({state:[{t:this.shape_102}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_103}]},1).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.shape_103).wait(57).to({_off:false},0).wait(58));

	// Layer 9
	this.shape_104 = new cjs.Shape();
	this.shape_104.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AATAIIglgP");
	this.shape_104.setTransform(298.1,245.2);

	this.shape_105 = new cjs.Shape();
	this.shape_105.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgZgLIAzAX");
	this.shape_105.setTransform(297.5,244.8);

	this.shape_106 = new cjs.Shape();
	this.shape_106.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgfgQIA/Ah");
	this.shape_106.setTransform(296.8,244.4);

	this.shape_107 = new cjs.Shape();
	this.shape_107.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AglgUIBLAp");
	this.shape_107.setTransform(296.2,243.9);

	this.shape_108 = new cjs.Shape();
	this.shape_108.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgrgYIBXAx");
	this.shape_108.setTransform(295.6,243.5);

	this.shape_109 = new cjs.Shape();
	this.shape_109.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgxgdIBjA7");
	this.shape_109.setTransform(295,243);

	this.shape_110 = new cjs.Shape();
	this.shape_110.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ag4ghIBwBD");
	this.shape_110.setTransform(294.4,242.6);

	this.shape_111 = new cjs.Shape();
	this.shape_111.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ag+glIB9BL");
	this.shape_111.setTransform(293.7,242.2);

	this.shape_112 = new cjs.Shape();
	this.shape_112.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhEgqICJBV");
	this.shape_112.setTransform(293.1,241.7);

	this.shape_113 = new cjs.Shape();
	this.shape_113.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhKguICVBd");
	this.shape_113.setTransform(292.5,241.3);

	this.shape_114 = new cjs.Shape();
	this.shape_114.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhQgzIChBn");
	this.shape_114.setTransform(291.9,240.8);

	this.shape_115 = new cjs.Shape();
	this.shape_115.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhXg3ICvBv");
	this.shape_115.setTransform(291.3,240.4);

	this.shape_116 = new cjs.Shape();
	this.shape_116.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ahdg7IC7B4");
	this.shape_116.setTransform(290.6,240);

	this.shape_117 = new cjs.Shape();
	this.shape_117.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhjhAIDHCB");
	this.shape_117.setTransform(290,239.5);

	this.shape_118 = new cjs.Shape();
	this.shape_118.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhphEIDTCJ");
	this.shape_118.setTransform(289.4,239.1);

	this.shape_119 = new cjs.Shape();
	this.shape_119.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhvhJIDfCT");
	this.shape_119.setTransform(288.8,238.6);

	this.shape_120 = new cjs.Shape();
	this.shape_120.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ah1hNIDsCb");
	this.shape_120.setTransform(288.2,238.2);

	this.shape_121 = new cjs.Shape();
	this.shape_121.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ah8hSID5Cl");
	this.shape_121.setTransform(287.5,237.8);

	this.shape_122 = new cjs.Shape();
	this.shape_122.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiChWIEFCt");
	this.shape_122.setTransform(286.9,237.3);

	this.shape_123 = new cjs.Shape();
	this.shape_123.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiIhaIERC1");
	this.shape_123.setTransform(286.3,236.9);

	this.shape_124 = new cjs.Shape();
	this.shape_124.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiOhfIEdC/");
	this.shape_124.setTransform(285.7,236.4);

	this.shape_125 = new cjs.Shape();
	this.shape_125.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiUhjIEpDH");
	this.shape_125.setTransform(285.1,236);

	this.shape_126 = new cjs.Shape();
	this.shape_126.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AibhoIE3DQ");
	this.shape_126.setTransform(284.4,235.6);

	this.shape_127 = new cjs.Shape();
	this.shape_127.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AihhsIFDDZ");
	this.shape_127.setTransform(283.8,235.1);

	this.shape_128 = new cjs.Shape();
	this.shape_128.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AinhwIFPDh");
	this.shape_128.setTransform(283.2,234.7);

	this.shape_129 = new cjs.Shape();
	this.shape_129.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("ACuB2Ilbjr");
	this.shape_129.setTransform(282.6,234.2);
	this.shape_129._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_104}]}).to({state:[{t:this.shape_105}]},1).to({state:[{t:this.shape_106}]},1).to({state:[{t:this.shape_107}]},1).to({state:[{t:this.shape_108}]},1).to({state:[{t:this.shape_109}]},1).to({state:[{t:this.shape_110}]},1).to({state:[{t:this.shape_111}]},1).to({state:[{t:this.shape_112}]},1).to({state:[{t:this.shape_113}]},1).to({state:[{t:this.shape_114}]},1).to({state:[{t:this.shape_115}]},1).to({state:[{t:this.shape_116}]},1).to({state:[{t:this.shape_117}]},1).to({state:[{t:this.shape_118}]},1).to({state:[{t:this.shape_119}]},1).to({state:[{t:this.shape_120}]},1).to({state:[{t:this.shape_121}]},1).to({state:[{t:this.shape_122}]},1).to({state:[{t:this.shape_123}]},1).to({state:[{t:this.shape_124}]},1).to({state:[{t:this.shape_125}]},1).to({state:[{t:this.shape_126}]},1).to({state:[{t:this.shape_127}]},1).to({state:[{t:this.shape_128}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_129}]},1).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.shape_129).wait(25).to({_off:false},0).wait(90));

	// Layer 11 copy 2
	this.shape_130 = new cjs.Shape();
	this.shape_130.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAZAGIgxgL");
	this.shape_130.setTransform(236,262.7);

	this.shape_131 = new cjs.Shape();
	this.shape_131.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgegGIA9AN");
	this.shape_131.setTransform(235.4,262.6);

	this.shape_132 = new cjs.Shape();
	this.shape_132.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgkgHIBJAP");
	this.shape_132.setTransform(234.8,262.5);

	this.shape_133 = new cjs.Shape();
	this.shape_133.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgqgJIBVAT");
	this.shape_133.setTransform(234.2,262.3);

	this.shape_134 = new cjs.Shape();
	this.shape_134.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgwgKIBhAV");
	this.shape_134.setTransform(233.6,262.2);

	this.shape_135 = new cjs.Shape();
	this.shape_135.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ag2gLIBsAX");
	this.shape_135.setTransform(233.1,262.1);

	this.shape_136 = new cjs.Shape();
	this.shape_136.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ag7gNIB4Aa");
	this.shape_136.setTransform(232.5,262);

	this.shape_137 = new cjs.Shape();
	this.shape_137.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhBgOICDAd");
	this.shape_137.setTransform(231.9,261.8);

	this.shape_138 = new cjs.Shape();
	this.shape_138.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhHgPICPAf");
	this.shape_138.setTransform(231.3,261.7);

	this.shape_139 = new cjs.Shape();
	this.shape_139.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhNgRICbAj");
	this.shape_139.setTransform(230.7,261.6);

	this.shape_140 = new cjs.Shape();
	this.shape_140.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhTgSICnAl");
	this.shape_140.setTransform(230.1,261.4);

	this.shape_141 = new cjs.Shape();
	this.shape_141.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhZgTICzAn");
	this.shape_141.setTransform(229.5,261.3);

	this.shape_142 = new cjs.Shape();
	this.shape_142.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhegUIC+Aq");
	this.shape_142.setTransform(229,261.2);

	this.shape_143 = new cjs.Shape();
	this.shape_143.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhlgWIDLAt");
	this.shape_143.setTransform(228.4,261);

	this.shape_144 = new cjs.Shape();
	this.shape_144.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhqgXIDVAv");
	this.shape_144.setTransform(227.8,260.9);

	this.shape_145 = new cjs.Shape();
	this.shape_145.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhwgYIDhAx");
	this.shape_145.setTransform(227.2,260.8);

	this.shape_146 = new cjs.Shape();
	this.shape_146.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ah2gZIDtA0");
	this.shape_146.setTransform(226.6,260.7);

	this.shape_147 = new cjs.Shape();
	this.shape_147.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ah8gbID5A3");
	this.shape_147.setTransform(226,260.5);

	this.shape_148 = new cjs.Shape();
	this.shape_148.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiCgcIEFA5");
	this.shape_148.setTransform(225.4,260.4);

	this.shape_149 = new cjs.Shape();
	this.shape_149.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiIgeIERA9");
	this.shape_149.setTransform(224.9,260.3);

	this.shape_150 = new cjs.Shape();
	this.shape_150.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiOgfIEdA/");
	this.shape_150.setTransform(224.3,260.1);

	this.shape_151 = new cjs.Shape();
	this.shape_151.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiTggIEnBB");
	this.shape_151.setTransform(223.7,260);

	this.shape_152 = new cjs.Shape();
	this.shape_152.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiZgiIEzBE");
	this.shape_152.setTransform(223.1,259.9);

	this.shape_153 = new cjs.Shape();
	this.shape_153.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("ACgAkIk/hH");
	this.shape_153.setTransform(222.5,259.7);
	this.shape_153._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_130}]},50).to({state:[{t:this.shape_131}]},1).to({state:[{t:this.shape_132}]},1).to({state:[{t:this.shape_133}]},1).to({state:[{t:this.shape_134}]},1).to({state:[{t:this.shape_135}]},1).to({state:[{t:this.shape_136}]},1).to({state:[{t:this.shape_137}]},1).to({state:[{t:this.shape_138}]},1).to({state:[{t:this.shape_139}]},1).to({state:[{t:this.shape_140}]},1).to({state:[{t:this.shape_141}]},1).to({state:[{t:this.shape_142}]},1).to({state:[{t:this.shape_143}]},1).to({state:[{t:this.shape_144}]},1).to({state:[{t:this.shape_145}]},1).to({state:[{t:this.shape_146}]},1).to({state:[{t:this.shape_147}]},1).to({state:[{t:this.shape_148}]},1).to({state:[{t:this.shape_149}]},1).to({state:[{t:this.shape_150}]},1).to({state:[{t:this.shape_151}]},1).to({state:[{t:this.shape_152}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.shape_153).wait(73).to({_off:false},0).wait(42));

	// Layer 11 copy
	this.shape_154 = new cjs.Shape();
	this.shape_154.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAcAAIg3AA");
	this.shape_154.setTransform(258.4,263.3);

	this.shape_155 = new cjs.Shape();
	this.shape_155.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgeAAIA9AA");
	this.shape_155.setTransform(258,263.3);

	this.shape_156 = new cjs.Shape();
	this.shape_156.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AghAAIBDAA");
	this.shape_156.setTransform(257.7,263.3);

	this.shape_157 = new cjs.Shape();
	this.shape_157.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AglAAIBLAA");
	this.shape_157.setTransform(257.4,263.3);

	this.shape_158 = new cjs.Shape();
	this.shape_158.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgpAAIBSAA");
	this.shape_158.setTransform(257,263.3);

	this.shape_159 = new cjs.Shape();
	this.shape_159.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgsAAIBZAA");
	this.shape_159.setTransform(256.7,263.3);

	this.shape_160 = new cjs.Shape();
	this.shape_160.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgvAAIBfAA");
	this.shape_160.setTransform(256.3,263.3);

	this.shape_161 = new cjs.Shape();
	this.shape_161.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgzAAIBnAA");
	this.shape_161.setTransform(256,263.3);

	this.shape_162 = new cjs.Shape();
	this.shape_162.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ag2AAIBtAA");
	this.shape_162.setTransform(255.7,263.3);

	this.shape_163 = new cjs.Shape();
	this.shape_163.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ag5AAIBzAA");
	this.shape_163.setTransform(255.3,263.3);

	this.shape_164 = new cjs.Shape();
	this.shape_164.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ag9AAIB7AA");
	this.shape_164.setTransform(255,263.3);

	this.shape_165 = new cjs.Shape();
	this.shape_165.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhAAAICBAA");
	this.shape_165.setTransform(254.6,263.3);

	this.shape_166 = new cjs.Shape();
	this.shape_166.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhEAAICJAA");
	this.shape_166.setTransform(254.3,263.3);

	this.shape_167 = new cjs.Shape();
	this.shape_167.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhHAAICPAA");
	this.shape_167.setTransform(253.9,263.3);

	this.shape_168 = new cjs.Shape();
	this.shape_168.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhLAAICXAA");
	this.shape_168.setTransform(253.6,263.3);

	this.shape_169 = new cjs.Shape();
	this.shape_169.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhOAAICdAA");
	this.shape_169.setTransform(253.3,263.3);

	this.shape_170 = new cjs.Shape();
	this.shape_170.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhRAAICkAA");
	this.shape_170.setTransform(252.9,263.3);

	this.shape_171 = new cjs.Shape();
	this.shape_171.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhVAAICrAA");
	this.shape_171.setTransform(252.6,263.3);

	this.shape_172 = new cjs.Shape();
	this.shape_172.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhYAAICxAA");
	this.shape_172.setTransform(252.2,263.3);

	this.shape_173 = new cjs.Shape();
	this.shape_173.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhcAAIC5AA");
	this.shape_173.setTransform(251.9,263.3);

	this.shape_174 = new cjs.Shape();
	this.shape_174.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhfAAIC/AA");
	this.shape_174.setTransform(251.5,263.3);

	this.shape_175 = new cjs.Shape();
	this.shape_175.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhiAAIDFAA");
	this.shape_175.setTransform(251.2,263.3);

	this.shape_176 = new cjs.Shape();
	this.shape_176.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhmAAIDNAA");
	this.shape_176.setTransform(250.9,263.3);

	this.shape_177 = new cjs.Shape();
	this.shape_177.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhqAAIDUAA");
	this.shape_177.setTransform(250.5,263.3);

	this.shape_178 = new cjs.Shape();
	this.shape_178.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhtAAIDbAA");
	this.shape_178.setTransform(250.2,263.3);

	this.shape_179 = new cjs.Shape();
	this.shape_179.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("ABxAAIjhAA");
	this.shape_179.setTransform(249.8,263.3);
	this.shape_179._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_154}]},25).to({state:[{t:this.shape_155}]},1).to({state:[{t:this.shape_156}]},1).to({state:[{t:this.shape_157}]},1).to({state:[{t:this.shape_158}]},1).to({state:[{t:this.shape_159}]},1).to({state:[{t:this.shape_160}]},1).to({state:[{t:this.shape_161}]},1).to({state:[{t:this.shape_162}]},1).to({state:[{t:this.shape_163}]},1).to({state:[{t:this.shape_164}]},1).to({state:[{t:this.shape_165}]},1).to({state:[{t:this.shape_166}]},1).to({state:[{t:this.shape_167}]},1).to({state:[{t:this.shape_168}]},1).to({state:[{t:this.shape_169}]},1).to({state:[{t:this.shape_170}]},1).to({state:[{t:this.shape_171}]},1).to({state:[{t:this.shape_172}]},1).to({state:[{t:this.shape_173}]},1).to({state:[{t:this.shape_174}]},1).to({state:[{t:this.shape_175}]},1).to({state:[{t:this.shape_176}]},1).to({state:[{t:this.shape_177}]},1).to({state:[{t:this.shape_178}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).to({state:[{t:this.shape_179}]},1).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.shape_179).wait(50).to({_off:false},0).wait(65));

	// Layer 11
	this.shape_180 = new cjs.Shape();
	this.shape_180.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAHgIIgMAS");
	this.shape_180.setTransform(298.6,248.2);

	this.shape_181 = new cjs.Shape();
	this.shape_181.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgNAMIAbgX");
	this.shape_181.setTransform(297.8,248.5);

	this.shape_182 = new cjs.Shape();
	this.shape_182.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgUAPIApgd");
	this.shape_182.setTransform(297.1,248.8);

	this.shape_183 = new cjs.Shape();
	this.shape_183.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgcASIA4gj");
	this.shape_183.setTransform(296.4,249.1);

	this.shape_184 = new cjs.Shape();
	this.shape_184.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgjAVIBHgp");
	this.shape_184.setTransform(295.6,249.3);

	this.shape_185 = new cjs.Shape();
	this.shape_185.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgqAYIBVgv");
	this.shape_185.setTransform(294.9,249.6);

	this.shape_186 = new cjs.Shape();
	this.shape_186.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgxAbIBkg1");
	this.shape_186.setTransform(294.2,249.9);

	this.shape_187 = new cjs.Shape();
	this.shape_187.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ag5AdIBzg5");
	this.shape_187.setTransform(293.4,250.2);

	this.shape_188 = new cjs.Shape();
	this.shape_188.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhAAgICBg/");
	this.shape_188.setTransform(292.7,250.5);

	this.shape_189 = new cjs.Shape();
	this.shape_189.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhIAjICRhF");
	this.shape_189.setTransform(291.9,250.8);

	this.shape_190 = new cjs.Shape();
	this.shape_190.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhPAmICfhL");
	this.shape_190.setTransform(291.2,251);

	this.shape_191 = new cjs.Shape();
	this.shape_191.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhWApICthR");
	this.shape_191.setTransform(290.5,251.3);

	this.shape_192 = new cjs.Shape();
	this.shape_192.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AheArIC9hV");
	this.shape_192.setTransform(289.7,251.6);

	this.shape_193 = new cjs.Shape();
	this.shape_193.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhlAuIDLhb");
	this.shape_193.setTransform(289,251.9);

	this.shape_194 = new cjs.Shape();
	this.shape_194.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhsAxIDZhh");
	this.shape_194.setTransform(288.3,252.2);

	this.shape_195 = new cjs.Shape();
	this.shape_195.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ah0A0IDphn");
	this.shape_195.setTransform(287.5,252.5);

	this.shape_196 = new cjs.Shape();
	this.shape_196.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ah7A3ID3ht");
	this.shape_196.setTransform(286.8,252.7);

	this.shape_197 = new cjs.Shape();
	this.shape_197.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiCA6IEGhz");
	this.shape_197.setTransform(286.1,253);

	this.shape_198 = new cjs.Shape();
	this.shape_198.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiKA9IEVh5");
	this.shape_198.setTransform(285.3,253.3);

	this.shape_199 = new cjs.Shape();
	this.shape_199.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiRA/IEjh9");
	this.shape_199.setTransform(284.6,253.6);

	this.shape_200 = new cjs.Shape();
	this.shape_200.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiZBCIEyiD");
	this.shape_200.setTransform(283.9,253.9);

	this.shape_201 = new cjs.Shape();
	this.shape_201.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AigBFIFBiJ");
	this.shape_201.setTransform(283.1,254.2);

	this.shape_202 = new cjs.Shape();
	this.shape_202.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AinBIIFPiP");
	this.shape_202.setTransform(282.4,254.4);

	this.shape_203 = new cjs.Shape();
	this.shape_203.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiuBKIFeiT");
	this.shape_203.setTransform(281.7,254.7);

	this.shape_204 = new cjs.Shape();
	this.shape_204.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ai2BOIFtib");
	this.shape_204.setTransform(280.9,255);

	this.shape_205 = new cjs.Shape();
	this.shape_205.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AC+hPIl7Cf");
	this.shape_205.setTransform(280.2,255.3);
	this.shape_205._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_180}]}).to({state:[{t:this.shape_181}]},1).to({state:[{t:this.shape_182}]},1).to({state:[{t:this.shape_183}]},1).to({state:[{t:this.shape_184}]},1).to({state:[{t:this.shape_185}]},1).to({state:[{t:this.shape_186}]},1).to({state:[{t:this.shape_187}]},1).to({state:[{t:this.shape_188}]},1).to({state:[{t:this.shape_189}]},1).to({state:[{t:this.shape_190}]},1).to({state:[{t:this.shape_191}]},1).to({state:[{t:this.shape_192}]},1).to({state:[{t:this.shape_193}]},1).to({state:[{t:this.shape_194}]},1).to({state:[{t:this.shape_195}]},1).to({state:[{t:this.shape_196}]},1).to({state:[{t:this.shape_197}]},1).to({state:[{t:this.shape_198}]},1).to({state:[{t:this.shape_199}]},1).to({state:[{t:this.shape_200}]},1).to({state:[{t:this.shape_201}]},1).to({state:[{t:this.shape_202}]},1).to({state:[{t:this.shape_203}]},1).to({state:[{t:this.shape_204}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).to({state:[{t:this.shape_205}]},1).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.shape_205).wait(25).to({_off:false},0).wait(90));

	// Layer 7 copy
	this.shape_206 = new cjs.Shape();
	this.shape_206.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgbgMIA3AZ");
	this.shape_206.setTransform(397.9,234.2);

	this.shape_207 = new cjs.Shape();
	this.shape_207.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgjgQIBHAh");
	this.shape_207.setTransform(398.7,234.5);

	this.shape_208 = new cjs.Shape();
	this.shape_208.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgrgUIBXAp");
	this.shape_208.setTransform(399.5,234.9);

	this.shape_209 = new cjs.Shape();
	this.shape_209.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ag0gYIBpAx");
	this.shape_209.setTransform(400.4,235.3);

	this.shape_210 = new cjs.Shape();
	this.shape_210.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ag8gcIB5A5");
	this.shape_210.setTransform(401.2,235.7);

	this.shape_211 = new cjs.Shape();
	this.shape_211.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhEggICJBB");
	this.shape_211.setTransform(402,236.1);

	this.shape_212 = new cjs.Shape();
	this.shape_212.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhNgkICbBJ");
	this.shape_212.setTransform(402.9,236.5);

	this.shape_213 = new cjs.Shape();
	this.shape_213.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhVgoICrBQ");
	this.shape_213.setTransform(403.7,236.9);

	this.shape_214 = new cjs.Shape();
	this.shape_214.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhdgrIC7BX");
	this.shape_214.setTransform(404.5,237.3);

	this.shape_215 = new cjs.Shape();
	this.shape_215.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhlgvIDLBf");
	this.shape_215.setTransform(405.3,237.6);

	this.shape_216 = new cjs.Shape();
	this.shape_216.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhtgzIDcBn");
	this.shape_216.setTransform(406.2,238);

	this.shape_217 = new cjs.Shape();
	this.shape_217.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ah2g3IDtBv");
	this.shape_217.setTransform(407,238.4);

	this.shape_218 = new cjs.Shape();
	this.shape_218.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ah+g7ID9B3");
	this.shape_218.setTransform(407.8,238.8);

	this.shape_219 = new cjs.Shape();
	this.shape_219.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiGg/IENB/");
	this.shape_219.setTransform(408.6,239.2);

	this.shape_220 = new cjs.Shape();
	this.shape_220.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiPhDIEeCH");
	this.shape_220.setTransform(409.5,239.6);

	this.shape_221 = new cjs.Shape();
	this.shape_221.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiXhGIEvCO");
	this.shape_221.setTransform(410.3,240);

	this.shape_222 = new cjs.Shape();
	this.shape_222.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AifhLIE/CW");
	this.shape_222.setTransform(411.1,240.4);

	this.shape_223 = new cjs.Shape();
	this.shape_223.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AinhOIFPCd");
	this.shape_223.setTransform(411.9,240.7);

	this.shape_224 = new cjs.Shape();
	this.shape_224.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiwhSIFhCl");
	this.shape_224.setTransform(412.8,241.1);

	this.shape_225 = new cjs.Shape();
	this.shape_225.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ai4hWIFxCt");
	this.shape_225.setTransform(413.6,241.5);

	this.shape_226 = new cjs.Shape();
	this.shape_226.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AjAhaIGBC1");
	this.shape_226.setTransform(414.4,241.9);

	this.shape_227 = new cjs.Shape();
	this.shape_227.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AjIheIGRC9");
	this.shape_227.setTransform(415.3,242.3);

	this.shape_228 = new cjs.Shape();
	this.shape_228.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AjRhiIGjDF");
	this.shape_228.setTransform(416.1,242.7);

	this.shape_229 = new cjs.Shape();
	this.shape_229.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AjZhmIGzDN");
	this.shape_229.setTransform(416.9,243.1);
	this.shape_229._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_206}]},43).to({state:[{t:this.shape_207}]},1).to({state:[{t:this.shape_208}]},1).to({state:[{t:this.shape_209}]},1).to({state:[{t:this.shape_210}]},1).to({state:[{t:this.shape_211}]},1).to({state:[{t:this.shape_212}]},1).to({state:[{t:this.shape_213}]},1).to({state:[{t:this.shape_214}]},1).to({state:[{t:this.shape_215}]},1).to({state:[{t:this.shape_216}]},1).to({state:[{t:this.shape_217}]},1).to({state:[{t:this.shape_218}]},1).to({state:[{t:this.shape_219}]},1).to({state:[{t:this.shape_220}]},1).to({state:[{t:this.shape_221}]},1).to({state:[{t:this.shape_222}]},1).to({state:[{t:this.shape_223}]},1).to({state:[{t:this.shape_224}]},1).to({state:[{t:this.shape_225}]},1).to({state:[{t:this.shape_226}]},1).to({state:[{t:this.shape_227}]},1).to({state:[{t:this.shape_228}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).to({state:[{t:this.shape_229}]},1).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.shape_229).wait(66).to({_off:false},0).wait(49));

	// Layer 7 copy 3
	this.shape_230 = new cjs.Shape();
	this.shape_230.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgVgBIArAD");
	this.shape_230.setTransform(340.6,226.5);

	this.shape_231 = new cjs.Shape();
	this.shape_231.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgvAFIAogIIA3AE");
	this.shape_231.setTransform(341,226.9);

	this.shape_232 = new cjs.Shape();
	this.shape_232.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhIAKIA8gTIBVAJ");
	this.shape_232.setTransform(341.4,227.5);

	this.shape_233 = new cjs.Shape();
	this.shape_233.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhhAQIBQgfIBzAN");
	this.shape_233.setTransform(341.8,228);

	this.shape_234 = new cjs.Shape();
	this.shape_234.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ah6AVIBkgpICRAQ");
	this.shape_234.setTransform(342.2,228.5);

	this.shape_235 = new cjs.Shape();
	this.shape_235.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiTAbIB4g1ICvAU");
	this.shape_235.setTransform(342.6,229.1);

	this.shape_236 = new cjs.Shape();
	this.shape_236.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AisAgICMg/IDNAX");
	this.shape_236.setTransform(342.9,229.6);

	this.shape_237 = new cjs.Shape();
	this.shape_237.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AjFAmIChhLIDrAb");
	this.shape_237.setTransform(343.3,230.2);

	this.shape_238 = new cjs.Shape();
	this.shape_238.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AjfAsIC1hWIEJAe");
	this.shape_238.setTransform(343.7,230.7);

	this.shape_239 = new cjs.Shape();
	this.shape_239.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Aj4AxIDJhhIEoAi");
	this.shape_239.setTransform(344.1,231.3);

	this.shape_240 = new cjs.Shape();
	this.shape_240.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AkRA2IDehrIFFAl");
	this.shape_240.setTransform(344.5,231.8);

	this.shape_241 = new cjs.Shape();
	this.shape_241.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AkqA8IDyh3IFjAp");
	this.shape_241.setTransform(344.9,232.3);

	this.shape_242 = new cjs.Shape();
	this.shape_242.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AlDBBIEGiCIGBAt");
	this.shape_242.setTransform(345.3,232.9);

	this.shape_243 = new cjs.Shape();
	this.shape_243.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AldBHIEbiNIGgAw");
	this.shape_243.setTransform(345.6,233.4);

	this.shape_244 = new cjs.Shape();
	this.shape_244.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Al2BNIEviYIG+Az");
	this.shape_244.setTransform(346,234);

	this.shape_245 = new cjs.Shape();
	this.shape_245.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AmPBSIFDijIHcA2");
	this.shape_245.setTransform(346.4,234.5);

	this.shape_246 = new cjs.Shape();
	this.shape_246.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AmoBYIFXivIH6A7");
	this.shape_246.setTransform(346.8,235);

	this.shape_247 = new cjs.Shape();
	this.shape_247.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AnBBdIFri5IIYA+");
	this.shape_247.setTransform(347.2,235.6);

	this.shape_248 = new cjs.Shape();
	this.shape_248.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AnbBjIGAjFII3BC");
	this.shape_248.setTransform(347.6,236.1);
	this.shape_248._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_230}]},25).to({state:[{t:this.shape_231}]},1).to({state:[{t:this.shape_232}]},1).to({state:[{t:this.shape_233}]},1).to({state:[{t:this.shape_234}]},1).to({state:[{t:this.shape_235}]},1).to({state:[{t:this.shape_236}]},1).to({state:[{t:this.shape_237}]},1).to({state:[{t:this.shape_238}]},1).to({state:[{t:this.shape_239}]},1).to({state:[{t:this.shape_240}]},1).to({state:[{t:this.shape_241}]},1).to({state:[{t:this.shape_242}]},1).to({state:[{t:this.shape_243}]},1).to({state:[{t:this.shape_244}]},1).to({state:[{t:this.shape_245}]},1).to({state:[{t:this.shape_246}]},1).to({state:[{t:this.shape_247}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).to({state:[{t:this.shape_248}]},1).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.shape_248).wait(43).to({_off:false},0).wait(72));

	// Layer 7
	this.shape_249 = new cjs.Shape();
	this.shape_249.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgBAJIADgS");
	this.shape_249.setTransform(300.2,245.1);

	this.shape_250 = new cjs.Shape();
	this.shape_250.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgIANIARgZ");
	this.shape_250.setTransform(301,244.7);

	this.shape_251 = new cjs.Shape();
	this.shape_251.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgQARIAhgh");
	this.shape_251.setTransform(301.7,244.3);

	this.shape_252 = new cjs.Shape();
	this.shape_252.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgYAUIAxgn");
	this.shape_252.setTransform(302.5,244);

	this.shape_253 = new cjs.Shape();
	this.shape_253.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AggAYIBBgv");
	this.shape_253.setTransform(303.3,243.6);

	this.shape_254 = new cjs.Shape();
	this.shape_254.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgnAbIBPg1");
	this.shape_254.setTransform(304,243.3);

	this.shape_255 = new cjs.Shape();
	this.shape_255.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgvAfIBfg9");
	this.shape_255.setTransform(304.8,242.9);

	this.shape_256 = new cjs.Shape();
	this.shape_256.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ag2AiIBthE");
	this.shape_256.setTransform(305.5,242.6);

	this.shape_257 = new cjs.Shape();
	this.shape_257.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ag+AmIB9hL");
	this.shape_257.setTransform(306.3,242.2);

	this.shape_258 = new cjs.Shape();
	this.shape_258.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhGAqICNhT");
	this.shape_258.setTransform(307.1,241.8);

	this.shape_259 = new cjs.Shape();
	this.shape_259.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhNAtICbhZ");
	this.shape_259.setTransform(307.8,241.5);

	this.shape_260 = new cjs.Shape();
	this.shape_260.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhVAxICrhh");
	this.shape_260.setTransform(308.6,241.1);

	this.shape_261 = new cjs.Shape();
	this.shape_261.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhcA0IC5hn");
	this.shape_261.setTransform(309.3,240.8);

	this.shape_262 = new cjs.Shape();
	this.shape_262.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhkA4IDJhv");
	this.shape_262.setTransform(310.1,240.4);

	this.shape_263 = new cjs.Shape();
	this.shape_263.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhsA7IDYh2");
	this.shape_263.setTransform(310.9,240.1);

	this.shape_264 = new cjs.Shape();
	this.shape_264.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhzA/IDnh9");
	this.shape_264.setTransform(311.6,239.7);

	this.shape_265 = new cjs.Shape();
	this.shape_265.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ah7BDID2iF");
	this.shape_265.setTransform(312.4,239.4);

	this.shape_266 = new cjs.Shape();
	this.shape_266.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiCBGIEFiL");
	this.shape_266.setTransform(313.1,239);

	this.shape_267 = new cjs.Shape();
	this.shape_267.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiKBKIEViT");
	this.shape_267.setTransform(313.9,238.6);

	this.shape_268 = new cjs.Shape();
	this.shape_268.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiRBNIEkiZ");
	this.shape_268.setTransform(314.7,238.3);

	this.shape_269 = new cjs.Shape();
	this.shape_269.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiZBRIEzih");
	this.shape_269.setTransform(315.4,237.9);

	this.shape_270 = new cjs.Shape();
	this.shape_270.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AigBUIFCio");
	this.shape_270.setTransform(316.2,237.6);

	this.shape_271 = new cjs.Shape();
	this.shape_271.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AioBYIFRiv");
	this.shape_271.setTransform(316.9,237.2);

	this.shape_272 = new cjs.Shape();
	this.shape_272.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiwBcIFhi3");
	this.shape_272.setTransform(317.7,236.9);

	this.shape_273 = new cjs.Shape();
	this.shape_273.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ai3BfIFvi9");
	this.shape_273.setTransform(318.5,236.5);

	this.shape_274 = new cjs.Shape();
	this.shape_274.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ai/BjIF/jF");
	this.shape_274.setTransform(319.2,236.1);
	this.shape_274._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_249}]}).to({state:[{t:this.shape_250}]},1).to({state:[{t:this.shape_251}]},1).to({state:[{t:this.shape_252}]},1).to({state:[{t:this.shape_253}]},1).to({state:[{t:this.shape_254}]},1).to({state:[{t:this.shape_255}]},1).to({state:[{t:this.shape_256}]},1).to({state:[{t:this.shape_257}]},1).to({state:[{t:this.shape_258}]},1).to({state:[{t:this.shape_259}]},1).to({state:[{t:this.shape_260}]},1).to({state:[{t:this.shape_261}]},1).to({state:[{t:this.shape_262}]},1).to({state:[{t:this.shape_263}]},1).to({state:[{t:this.shape_264}]},1).to({state:[{t:this.shape_265}]},1).to({state:[{t:this.shape_266}]},1).to({state:[{t:this.shape_267}]},1).to({state:[{t:this.shape_268}]},1).to({state:[{t:this.shape_269}]},1).to({state:[{t:this.shape_270}]},1).to({state:[{t:this.shape_271}]},1).to({state:[{t:this.shape_272}]},1).to({state:[{t:this.shape_273}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).to({state:[{t:this.shape_274}]},1).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.shape_274).wait(25).to({_off:false},0).wait(90));

	// Layer 10
	this.shape_275 = new cjs.Shape();
	this.shape_275.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AANgXIgZAu");
	this.shape_275.setTransform(119.8,386.4);

	this.shape_276 = new cjs.Shape();
	this.shape_276.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgTAlIAnhI");
	this.shape_276.setTransform(119.1,387.7);

	this.shape_277 = new cjs.Shape();
	this.shape_277.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgZAxIAzhh");
	this.shape_277.setTransform(118.4,389);

	this.shape_278 = new cjs.Shape();
	this.shape_278.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AggA/IBBh9");
	this.shape_278.setTransform(117.7,390.3);

	this.shape_279 = new cjs.Shape();
	this.shape_279.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgnBMIBPiX");
	this.shape_279.setTransform(117,391.6);

	this.shape_280 = new cjs.Shape();
	this.shape_280.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AguBYIBdiv");
	this.shape_280.setTransform(116.3,392.8);

	this.shape_281 = new cjs.Shape();
	this.shape_281.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ag1BlIBrjJ");
	this.shape_281.setTransform(115.6,394.1);

	this.shape_282 = new cjs.Shape();
	this.shape_282.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ag8ByIB5jj");
	this.shape_282.setTransform(114.9,395.4);

	this.shape_283 = new cjs.Shape();
	this.shape_283.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhDB/ICHj9");
	this.shape_283.setTransform(114.2,396.7);

	this.shape_284 = new cjs.Shape();
	this.shape_284.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhKCMICVkX");
	this.shape_284.setTransform(113.5,398);

	this.shape_285 = new cjs.Shape();
	this.shape_285.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhRCZICjkx");
	this.shape_285.setTransform(112.8,399.3);

	this.shape_286 = new cjs.Shape();
	this.shape_286.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhYCmICxlL");
	this.shape_286.setTransform(112.1,400.6);

	this.shape_287 = new cjs.Shape();
	this.shape_287.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AheCzIC9ll");
	this.shape_287.setTransform(111.5,401.9);

	this.shape_288 = new cjs.Shape();
	this.shape_288.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhmDAIDNl/");
	this.shape_288.setTransform(110.8,403.2);

	this.shape_289 = new cjs.Shape();
	this.shape_289.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhtDNIDbmZ");
	this.shape_289.setTransform(110.1,404.5);

	this.shape_290 = new cjs.Shape();
	this.shape_290.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhzDaIDomz");
	this.shape_290.setTransform(109.4,405.8);

	this.shape_291 = new cjs.Shape();
	this.shape_291.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ah6DnID1nN");
	this.shape_291.setTransform(108.7,407.1);

	this.shape_292 = new cjs.Shape();
	this.shape_292.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("ACCjzIkDHn");
	this.shape_292.setTransform(108,408.4);
	this.shape_292._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_275}]},84).to({state:[{t:this.shape_276}]},1).to({state:[{t:this.shape_277}]},1).to({state:[{t:this.shape_278}]},1).to({state:[{t:this.shape_279}]},1).to({state:[{t:this.shape_280}]},1).to({state:[{t:this.shape_281}]},1).to({state:[{t:this.shape_282}]},1).to({state:[{t:this.shape_283}]},1).to({state:[{t:this.shape_284}]},1).to({state:[{t:this.shape_285}]},1).to({state:[{t:this.shape_286}]},1).to({state:[{t:this.shape_287}]},1).to({state:[{t:this.shape_288}]},1).to({state:[{t:this.shape_289}]},1).to({state:[{t:this.shape_290}]},1).to({state:[{t:this.shape_291}]},1).to({state:[{t:this.shape_292}]},1).to({state:[{t:this.shape_292}]},1).to({state:[{t:this.shape_292}]},1).to({state:[{t:this.shape_292}]},1).to({state:[{t:this.shape_292}]},1).to({state:[{t:this.shape_292}]},1).to({state:[{t:this.shape_292}]},1).to({state:[{t:this.shape_292}]},1).to({state:[{t:this.shape_292}]},1).to({state:[{t:this.shape_292}]},1).to({state:[{t:this.shape_292}]},1).to({state:[{t:this.shape_292}]},1).to({state:[{t:this.shape_292}]},1).to({state:[{t:this.shape_292}]},1).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.shape_292).wait(101).to({_off:false},0).wait(14));

	// Layer 2 copy 2
	this.shape_293 = new cjs.Shape();
	this.shape_293.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAYAAIgvAA");
	this.shape_293.setTransform(151.6,384);

	this.shape_294 = new cjs.Shape();
	this.shape_294.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AghAAIBDAA");
	this.shape_294.setTransform(150.6,384);

	this.shape_295 = new cjs.Shape();
	this.shape_295.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgqAAIBVAA");
	this.shape_295.setTransform(149.7,384);

	this.shape_296 = new cjs.Shape();
	this.shape_296.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ag0AAIBpAA");
	this.shape_296.setTransform(148.8,384);

	this.shape_297 = new cjs.Shape();
	this.shape_297.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ag9AAIB7AA");
	this.shape_297.setTransform(147.8,384);

	this.shape_298 = new cjs.Shape();
	this.shape_298.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhGAAICNAA");
	this.shape_298.setTransform(146.9,384);

	this.shape_299 = new cjs.Shape();
	this.shape_299.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhPAAICgAA");
	this.shape_299.setTransform(146,384);

	this.shape_300 = new cjs.Shape();
	this.shape_300.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhZAAICzAA");
	this.shape_300.setTransform(145,384);

	this.shape_301 = new cjs.Shape();
	this.shape_301.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhiAAIDFAA");
	this.shape_301.setTransform(144.1,384);

	this.shape_302 = new cjs.Shape();
	this.shape_302.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhsAAIDZAA");
	this.shape_302.setTransform(143.1,384);

	this.shape_303 = new cjs.Shape();
	this.shape_303.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ah1AAIDrAA");
	this.shape_303.setTransform(142.2,384);

	this.shape_304 = new cjs.Shape();
	this.shape_304.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ah/AAID/AA");
	this.shape_304.setTransform(141.3,384);

	this.shape_305 = new cjs.Shape();
	this.shape_305.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiIAAIERAA");
	this.shape_305.setTransform(140.3,384);

	this.shape_306 = new cjs.Shape();
	this.shape_306.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiRAAIEjAA");
	this.shape_306.setTransform(139.4,384);

	this.shape_307 = new cjs.Shape();
	this.shape_307.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AibAAIE2AA");
	this.shape_307.setTransform(138.5,384);

	this.shape_308 = new cjs.Shape();
	this.shape_308.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AClAAIlJAA");
	this.shape_308.setTransform(137.5,384);
	this.shape_308._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_293}]},69).to({state:[{t:this.shape_294}]},1).to({state:[{t:this.shape_295}]},1).to({state:[{t:this.shape_296}]},1).to({state:[{t:this.shape_297}]},1).to({state:[{t:this.shape_298}]},1).to({state:[{t:this.shape_299}]},1).to({state:[{t:this.shape_300}]},1).to({state:[{t:this.shape_301}]},1).to({state:[{t:this.shape_302}]},1).to({state:[{t:this.shape_303}]},1).to({state:[{t:this.shape_304}]},1).to({state:[{t:this.shape_305}]},1).to({state:[{t:this.shape_306}]},1).to({state:[{t:this.shape_307}]},1).to({state:[{t:this.shape_308}]},1).to({state:[{t:this.shape_308}]},1).to({state:[{t:this.shape_308}]},1).to({state:[{t:this.shape_308}]},1).to({state:[{t:this.shape_308}]},1).to({state:[{t:this.shape_308}]},1).to({state:[{t:this.shape_308}]},1).to({state:[{t:this.shape_308}]},1).to({state:[{t:this.shape_308}]},1).to({state:[{t:this.shape_308}]},1).to({state:[{t:this.shape_308}]},1).to({state:[{t:this.shape_308}]},1).to({state:[{t:this.shape_308}]},1).to({state:[{t:this.shape_308}]},1).to({state:[{t:this.shape_308}]},1).to({state:[{t:this.shape_308}]},1).to({state:[{t:this.shape_308}]},1).to({state:[{t:this.shape_308}]},1).to({state:[{t:this.shape_308}]},1).to({state:[{t:this.shape_308}]},1).to({state:[{t:this.shape_308}]},1).to({state:[{t:this.shape_308}]},1).to({state:[{t:this.shape_308}]},1).to({state:[{t:this.shape_308}]},1).to({state:[{t:this.shape_308}]},1).to({state:[{t:this.shape_308}]},1).to({state:[{t:this.shape_308}]},1).to({state:[{t:this.shape_308}]},1).to({state:[{t:this.shape_308}]},1).to({state:[{t:this.shape_308}]},1).to({state:[{t:this.shape_308}]},1).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.shape_308).wait(84).to({_off:false},0).wait(31));

	// Layer 2 copy
	this.shape_309 = new cjs.Shape();
	this.shape_309.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAQgIIgfAR");
	this.shape_309.setTransform(235.4,336.9);

	this.shape_310 = new cjs.Shape();
	this.shape_310.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgdARIA6gh");
	this.shape_310.setTransform(234.1,337.7);

	this.shape_311 = new cjs.Shape();
	this.shape_311.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgqAZIBVgx");
	this.shape_311.setTransform(232.7,338.5);

	this.shape_312 = new cjs.Shape();
	this.shape_312.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ag3AgIBvg/");
	this.shape_312.setTransform(231.4,339.2);

	this.shape_313 = new cjs.Shape();
	this.shape_313.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhFAoICKhP");
	this.shape_313.setTransform(230.1,340);

	this.shape_314 = new cjs.Shape();
	this.shape_314.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhSAwIClhf");
	this.shape_314.setTransform(228.7,340.8);

	this.shape_315 = new cjs.Shape();
	this.shape_315.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhfA4IC/hv");
	this.shape_315.setTransform(227.4,341.6);

	this.shape_316 = new cjs.Shape();
	this.shape_316.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhsA/IDZh9");
	this.shape_316.setTransform(226.1,342.3);

	this.shape_317 = new cjs.Shape();
	this.shape_317.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ah6BHID1iN");
	this.shape_317.setTransform(224.8,343.1);

	this.shape_318 = new cjs.Shape();
	this.shape_318.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiHBOIEPic");
	this.shape_318.setTransform(223.4,343.9);

	this.shape_319 = new cjs.Shape();
	this.shape_319.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiUBWIEpir");
	this.shape_319.setTransform(222.1,344.6);

	this.shape_320 = new cjs.Shape();
	this.shape_320.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiiBeIFFi7");
	this.shape_320.setTransform(220.8,345.4);

	this.shape_321 = new cjs.Shape();
	this.shape_321.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AivBmIFfjK");
	this.shape_321.setTransform(219.4,346.2);

	this.shape_322 = new cjs.Shape();
	this.shape_322.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ai8BtIF5jZ");
	this.shape_322.setTransform(218.1,346.9);

	this.shape_323 = new cjs.Shape();
	this.shape_323.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AjJB1IGTjp");
	this.shape_323.setTransform(216.8,347.7);

	this.shape_324 = new cjs.Shape();
	this.shape_324.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AjWB9IGuj5");
	this.shape_324.setTransform(215.5,348.5);

	this.shape_325 = new cjs.Shape();
	this.shape_325.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AjkCEIHJkH");
	this.shape_325.setTransform(214.1,349.2);

	this.shape_326 = new cjs.Shape();
	this.shape_326.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AjxCMIHjkX");
	this.shape_326.setTransform(212.8,350);

	this.shape_327 = new cjs.Shape();
	this.shape_327.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Aj+CUIH+kn");
	this.shape_327.setTransform(211.5,350.8);

	this.shape_328 = new cjs.Shape();
	this.shape_328.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AkMCcIIZk3");
	this.shape_328.setTransform(210.1,351.6);

	this.shape_329 = new cjs.Shape();
	this.shape_329.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AkZCjIIzlF");
	this.shape_329.setTransform(208.8,352.3);

	this.shape_330 = new cjs.Shape();
	this.shape_330.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AkmCrIJNlV");
	this.shape_330.setTransform(207.5,353.1);

	this.shape_331 = new cjs.Shape();
	this.shape_331.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ak0CyIJplk");
	this.shape_331.setTransform(206.1,353.9);

	this.shape_332 = new cjs.Shape();
	this.shape_332.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AlBC6IKDlz");
	this.shape_332.setTransform(204.8,354.6);

	this.shape_333 = new cjs.Shape();
	this.shape_333.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AlODCIKdmD");
	this.shape_333.setTransform(203.5,355.4);

	this.shape_334 = new cjs.Shape();
	this.shape_334.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AlbDKIK3mS");
	this.shape_334.setTransform(202.2,356.2);

	this.shape_335 = new cjs.Shape();
	this.shape_335.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AlpDRILTmh");
	this.shape_335.setTransform(200.8,356.9);

	this.shape_336 = new cjs.Shape();
	this.shape_336.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Al2DZILtmx");
	this.shape_336.setTransform(199.5,357.7);

	this.shape_337 = new cjs.Shape();
	this.shape_337.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AmDDgIMHm/");
	this.shape_337.setTransform(198.2,358.5);

	this.shape_338 = new cjs.Shape();
	this.shape_338.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AmRDoIMjnP");
	this.shape_338.setTransform(196.8,359.2);

	this.shape_339 = new cjs.Shape();
	this.shape_339.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AGfjvIs9Hf");
	this.shape_339.setTransform(195.5,360);
	this.shape_339._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_309}]},39).to({state:[{t:this.shape_310}]},1).to({state:[{t:this.shape_311}]},1).to({state:[{t:this.shape_312}]},1).to({state:[{t:this.shape_313}]},1).to({state:[{t:this.shape_314}]},1).to({state:[{t:this.shape_315}]},1).to({state:[{t:this.shape_316}]},1).to({state:[{t:this.shape_317}]},1).to({state:[{t:this.shape_318}]},1).to({state:[{t:this.shape_319}]},1).to({state:[{t:this.shape_320}]},1).to({state:[{t:this.shape_321}]},1).to({state:[{t:this.shape_322}]},1).to({state:[{t:this.shape_323}]},1).to({state:[{t:this.shape_324}]},1).to({state:[{t:this.shape_325}]},1).to({state:[{t:this.shape_326}]},1).to({state:[{t:this.shape_327}]},1).to({state:[{t:this.shape_328}]},1).to({state:[{t:this.shape_329}]},1).to({state:[{t:this.shape_330}]},1).to({state:[{t:this.shape_331}]},1).to({state:[{t:this.shape_332}]},1).to({state:[{t:this.shape_333}]},1).to({state:[{t:this.shape_334}]},1).to({state:[{t:this.shape_335}]},1).to({state:[{t:this.shape_336}]},1).to({state:[{t:this.shape_337}]},1).to({state:[{t:this.shape_338}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).to({state:[{t:this.shape_339}]},1).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.shape_339).wait(69).to({_off:false},0).wait(46));

	// Layer 2
	this.shape_340 = new cjs.Shape();
	this.shape_340.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AAEgFIgHAL");
	this.shape_340.setTransform(299.6,246.6);

	this.shape_341 = new cjs.Shape();
	this.shape_341.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgLASIAXgj");
	this.shape_341.setTransform(298.8,247.8);

	this.shape_342 = new cjs.Shape();
	this.shape_342.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgTAdIAng5");
	this.shape_342.setTransform(298,248.9);

	this.shape_343 = new cjs.Shape();
	this.shape_343.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgbApIA3hQ");
	this.shape_343.setTransform(297.2,250.1);

	this.shape_344 = new cjs.Shape();
	this.shape_344.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgjA0IBHhn");
	this.shape_344.setTransform(296.4,251.2);

	this.shape_345 = new cjs.Shape();
	this.shape_345.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgrA/IBXh9");
	this.shape_345.setTransform(295.6,252.3);

	this.shape_346 = new cjs.Shape();
	this.shape_346.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AgzBKIBniT");
	this.shape_346.setTransform(294.8,253.5);

	this.shape_347 = new cjs.Shape();
	this.shape_347.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ag7BWIB3ir");
	this.shape_347.setTransform(294,254.6);

	this.shape_348 = new cjs.Shape();
	this.shape_348.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhDBhICHjB");
	this.shape_348.setTransform(293.2,255.7);

	this.shape_349 = new cjs.Shape();
	this.shape_349.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhLBtICXjZ");
	this.shape_349.setTransform(292.4,256.9);

	this.shape_350 = new cjs.Shape();
	this.shape_350.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhTB4ICnjv");
	this.shape_350.setTransform(291.6,258);

	this.shape_351 = new cjs.Shape();
	this.shape_351.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhbCEIC3kG");
	this.shape_351.setTransform(290.8,259.2);

	this.shape_352 = new cjs.Shape();
	this.shape_352.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhjCPIDHkd");
	this.shape_352.setTransform(290,260.3);

	this.shape_353 = new cjs.Shape();
	this.shape_353.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhrCaIDXkz");
	this.shape_353.setTransform(289.2,261.4);

	this.shape_354 = new cjs.Shape();
	this.shape_354.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AhzCmIDnlL");
	this.shape_354.setTransform(288.4,262.6);

	this.shape_355 = new cjs.Shape();
	this.shape_355.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ah6CxID2lh");
	this.shape_355.setTransform(287.7,263.7);

	this.shape_356 = new cjs.Shape();
	this.shape_356.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiDC8IEGl3");
	this.shape_356.setTransform(286.9,264.8);

	this.shape_357 = new cjs.Shape();
	this.shape_357.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiKDIIEVmP");
	this.shape_357.setTransform(286.1,266);

	this.shape_358 = new cjs.Shape();
	this.shape_358.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiTDTIEnml");
	this.shape_358.setTransform(285.3,267.1);

	this.shape_359 = new cjs.Shape();
	this.shape_359.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AibDfIE3m9");
	this.shape_359.setTransform(284.5,268.3);

	this.shape_360 = new cjs.Shape();
	this.shape_360.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiiDqIFGnT");
	this.shape_360.setTransform(283.7,269.4);

	this.shape_361 = new cjs.Shape();
	this.shape_361.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AirD1IFWnp");
	this.shape_361.setTransform(282.9,270.5);

	this.shape_362 = new cjs.Shape();
	this.shape_362.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AiyEBIFloA");
	this.shape_362.setTransform(282.1,271.7);

	this.shape_363 = new cjs.Shape();
	this.shape_363.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Ai7EMIF3oX");
	this.shape_363.setTransform(281.3,272.8);

	this.shape_364 = new cjs.Shape();
	this.shape_364.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AjDEXIGHot");
	this.shape_364.setTransform(280.5,273.9);

	this.shape_365 = new cjs.Shape();
	this.shape_365.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AjKEjIGVpF");
	this.shape_365.setTransform(279.7,275.1);

	this.shape_366 = new cjs.Shape();
	this.shape_366.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AjSEuIGlpb");
	this.shape_366.setTransform(278.9,276.2);

	this.shape_367 = new cjs.Shape();
	this.shape_367.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AjaE5IG1py");
	this.shape_367.setTransform(278.1,277.4);

	this.shape_368 = new cjs.Shape();
	this.shape_368.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AjiFFIHFqJ");
	this.shape_368.setTransform(277.3,278.5);

	this.shape_369 = new cjs.Shape();
	this.shape_369.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AjqFQIHVqf");
	this.shape_369.setTransform(276.5,279.6);

	this.shape_370 = new cjs.Shape();
	this.shape_370.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AjyFcIHlq3");
	this.shape_370.setTransform(275.7,280.8);

	this.shape_371 = new cjs.Shape();
	this.shape_371.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("Aj6FnIH1rN");
	this.shape_371.setTransform(274.9,281.9);

	this.shape_372 = new cjs.Shape();
	this.shape_372.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AkCFyIIFrj");
	this.shape_372.setTransform(274.1,283);

	this.shape_373 = new cjs.Shape();
	this.shape_373.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AkKF+IIVr7");
	this.shape_373.setTransform(273.3,284.2);

	this.shape_374 = new cjs.Shape();
	this.shape_374.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AkSGJIIlsR");
	this.shape_374.setTransform(272.5,285.3);

	this.shape_375 = new cjs.Shape();
	this.shape_375.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AkaGUII1sn");
	this.shape_375.setTransform(271.7,286.5);

	this.shape_376 = new cjs.Shape();
	this.shape_376.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AkiGgIJFs/");
	this.shape_376.setTransform(270.9,287.6);

	this.shape_377 = new cjs.Shape();
	this.shape_377.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AkqGrIJVtV");
	this.shape_377.setTransform(270.1,288.7);

	this.shape_378 = new cjs.Shape();
	this.shape_378.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AkyG2IJlts");
	this.shape_378.setTransform(269.3,289.9);

	this.shape_379 = new cjs.Shape();
	this.shape_379.graphics.f().s("#FFFFFF").ss(4.6,1,1).p("AE7nBIp1OD");
	this.shape_379.setTransform(268.5,291);
	this.shape_379._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_340}]}).to({state:[{t:this.shape_341}]},1).to({state:[{t:this.shape_342}]},1).to({state:[{t:this.shape_343}]},1).to({state:[{t:this.shape_344}]},1).to({state:[{t:this.shape_345}]},1).to({state:[{t:this.shape_346}]},1).to({state:[{t:this.shape_347}]},1).to({state:[{t:this.shape_348}]},1).to({state:[{t:this.shape_349}]},1).to({state:[{t:this.shape_350}]},1).to({state:[{t:this.shape_351}]},1).to({state:[{t:this.shape_352}]},1).to({state:[{t:this.shape_353}]},1).to({state:[{t:this.shape_354}]},1).to({state:[{t:this.shape_355}]},1).to({state:[{t:this.shape_356}]},1).to({state:[{t:this.shape_357}]},1).to({state:[{t:this.shape_358}]},1).to({state:[{t:this.shape_359}]},1).to({state:[{t:this.shape_360}]},1).to({state:[{t:this.shape_361}]},1).to({state:[{t:this.shape_362}]},1).to({state:[{t:this.shape_363}]},1).to({state:[{t:this.shape_364}]},1).to({state:[{t:this.shape_365}]},1).to({state:[{t:this.shape_366}]},1).to({state:[{t:this.shape_367}]},1).to({state:[{t:this.shape_368}]},1).to({state:[{t:this.shape_369}]},1).to({state:[{t:this.shape_370}]},1).to({state:[{t:this.shape_371}]},1).to({state:[{t:this.shape_372}]},1).to({state:[{t:this.shape_373}]},1).to({state:[{t:this.shape_374}]},1).to({state:[{t:this.shape_375}]},1).to({state:[{t:this.shape_376}]},1).to({state:[{t:this.shape_377}]},1).to({state:[{t:this.shape_378}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).to({state:[{t:this.shape_379}]},1).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.shape_379).wait(39).to({_off:false},0).wait(76));

	// Layer 1
	this.instance = new lib.headerimg();
	this.instance.parent = this;
	this.instance.setTransform(-552,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(115));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-302,250,1600,500);
// library properties:
lib.properties = {
	width: 500,
	height: 500,
	fps: 48,
	color: "#FFFFFF",
	opacity: 0.00,
	webfonts: {},
	manifest: [
		{src:"images/headerimg.jpg", id:"headerimg"}
	],
	preloads: []
};




})(lib = lib||{}, images = images||{}, createjs = createjs||{}, ss = ss||{}, AdobeAn = AdobeAn||{});
var lib, images, createjs, ss, AdobeAn;